/**
 * The grip that resizes the right-hand panel: a strip down its left edge, and
 * the circular handle the design puts at the top of that edge.
 *
 * The strip is what most people will hit; the handle is what tells them the
 * edge can be dragged at all. Both drive the same drag, and the handle is a
 * button so the arrow keys work too.
 */

import { ColumnWidthOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React, { FC } from 'react';

interface AOPPanelResizeHandleProps {
	onPointerDown: (event: React.PointerEvent) => void;
	onKeyDown: (event: React.KeyboardEvent) => void;
	/** Which edge of the panel the grip sits on. */
	edge?: 'left' | 'right';
}

export const AOPPanelResizeHandle: FC<AOPPanelResizeHandleProps> = ({
	onPointerDown,
	onKeyDown,
	edge = 'left',
}) => (
	<>
		<span
			aria-hidden
			onPointerDown={onPointerDown}
			className={`absolute inset-y-0 z-20 w-1 cursor-col-resize hover:bg-purple-3 ${
				edge === 'left' ? 'left-0' : 'right-0'
			}`}
		/>
		<Tooltip title="Drag to resize" placement={edge === 'left' ? 'left' : 'right'}>
			<button
				type="button"
				aria-label="Resize panel"
				onPointerDown={onPointerDown}
				onKeyDown={onKeyDown}
				className={`absolute top-s z-30 inline-flex h-6 w-6 cursor-col-resize items-center justify-center rounded-full border border-solid border-grey-4 bg-grey-1 p-0 text-character-secondary shadow-md hover:text-purple-6 ${
					edge === 'left' ? '-left-3' : '-right-3'
				}`}
			>
				<ColumnWidthOutlined />
			</button>
		</Tooltip>
	</>
);
